var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-list',{staticClass:"student-list",attrs:{"media-list":""}},[_c('students-query',{scopedSlots:_vm._u([{key:"default",fn:function({ students }){return [_c('ul',_vm._l((students),function(student){return _c('student-list-item',{key:student.id,attrs:{"student":student}})}),1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }